export const constant =
{
  localStorageType: {any: 0, localStorage: 1, sessionStorage: 2,cookiesStorage: 3},
  promptMessageType: { success: "success", info: "info", warn: "warn", error: "error"},
  defaultLanguage: 'E',  
};
export interface Column {
  field: string;
  header: string;
}

export const PROJECT_COLUMNS: Column[] = [
  { field: 'id', header: 'Project Id' },
  { field: 'projectNumber', header: 'Project Number' },
  { field: 'title', header: 'Project Title' },
  { field: 'projectStatus', header: 'Status' },
  { field: 'statusDate', header: 'Start Date' },
  { field: 'description', header: 'Project Description' },
  { field: 'projectRemark', header: 'Project Remarks' },
  { field: 'createdByOID', header: 'Project Creator' }
];

export const CERTIFICATE_COLUMNS: Column[] = [
  { field: 'id', header: 'Certificate ID' },
  { field: 'projectNumber', header: 'Project Number' },
  { field: 'certificateDate', header: 'Certificate Date' },
  { field: 'createdBy', header: 'Issued By' },
  { field: 'buildingProject', header: 'Building Project' },
  { field: 'certificateRemarks', header: 'Certificate Remarks' }
];

export const TEST_COLUMNS: Column[] = [
  { field: 'id', header: 'TEST ID' },
  { field: 'projectNumber', header: 'Project Number' },
  { field: 'testdate', header: 'Test Date' },
  { field: 'testLab', header: 'Test Lab' },
  { field: 'description', header: 'Test Description' },
  { field: 'remarks', header: 'Test Remarks' }
];

export const GLASS_COLUMNS: Column[] = [
  { field: 'ceId', header: 'CE ID' },
  { field: 'ceGlassType', header: 'CE Glass Type' },
  { field: 'ceUnit', header: 'CE Unit' },
  { field: 'ceGlassDescription', header: 'CE Glass Description' },
  { field: 'ceRemarks', header: 'CE Remarks' }
];

export const FRAME_COLUMNS: Column[] = [
  { field: 'ceId', header: 'CE ID' },
  { field: 'frameName', header: 'Frame Name' },
  { field: 'material', header: 'Material' },
  { field: 'intumescentMaterialType', header: 'Intumescent Material Type' },
  { field: 'intumescentDimension', header: 'Intumescent Dimension' },
  { field: 'glazingMaterial', header: 'Glazing Material' },
  { field: 'frameRemarks', header: 'Frame Remarks' }
];
